import { Entry } from '../Entry'

export function Entry20260715() {
  return (
    <Entry title="2026 Jul 15 - v3.11.17">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/26905/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
